import { TestInterface } from '@xpect-ai/e2e-test-framework-react/lib/interfaces'
import app from '../app/app.e2etest'

// NOTE: If DefaultTestStepExecutor should be overriden please add property testStepExecutor with reference to a stepExecutorFunction
export default [app] as Array<Array<TestInterface>>
